export const spacingNumeric = {
  none: 0,
  tiny: 4,
  xxSmall: 8,
  xSmall: 12,
  small: 16,
  medium: 24,
  large: 32,
  xLarge: 48,
  xxLarge: 64,
  huge: 80,
} as const

export const spacing = {
  none: `${spacingNumeric.none}px`,
  tiny: `${spacingNumeric.tiny}px`,
  xxSmall: `${spacingNumeric.xxSmall}px`,
  xSmall: `${spacingNumeric.xSmall}px`,
  small: `${spacingNumeric.small}px`,
  medium: `${spacingNumeric.medium}px`,
  large: `${spacingNumeric.large}px`,
  xLarge: `${spacingNumeric.xLarge}px`,
  xxLarge: `${spacingNumeric.xxLarge}px`,
  huge: `${spacingNumeric.huge}px`,
} as const

export type Spacing = keyof typeof spacing
